import DynamicPage from 'components/DynamicPage';

const Legal = () => {
  return(
    <DynamicPage url="/legal" />
  )
}

export default Legal;
